import { atom } from "jotai";

export const socketConnectedAtom = atom(false);
